function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { getFilesFromDragEvent } from "html-dir-content";
import { useUploadyContext } from "@rpldy/shared-ui";
var UploadDropZone = /*#__PURE__*/forwardRef(function (props, ref) {
  var containerRef = useRef(null);
  useImperativeHandle(ref, function () {
    return containerRef.current;
  }, []);

  var _useUploadyContext = useUploadyContext(),
      upload = _useUploadyContext.upload;

  var className = props.className,
      id = props.id,
      children = props.children,
      onDragOverClassName = props.onDragOverClassName,
      dropHandler = props.dropHandler,
      htmlDirContentParams = props.htmlDirContentParams,
      extraProps = props.extraProps,
      uploadOptions = _objectWithoutProperties(props, ["className", "id", "children", "onDragOverClassName", "dropHandler", "htmlDirContentParams", "extraProps"]); //using ref so upload can stay memoized


  var uploadOptionsRef = useRef();
  uploadOptionsRef.current = uploadOptions;
  var handleEnd = useCallback(function () {
    if (containerRef.current && onDragOverClassName) {
      containerRef.current.classList.remove(onDragOverClassName);
    }
  }, [onDragOverClassName, containerRef]);
  var dropFileHandler = useCallback(function (e) {
    return dropHandler ? Promise.resolve(dropHandler(e)) : getFilesFromDragEvent(e, htmlDirContentParams || {});
  }, [dropHandler, htmlDirContentParams]);
  var handleDropUpload = useCallback(function (e) {
    dropFileHandler(e).then(function (files) {
      upload(files, uploadOptionsRef.current);
    });
  }, [upload, dropFileHandler, uploadOptionsRef]);
  var onDragOver = useCallback(function (e) {
    e.preventDefault();

    if (containerRef.current && onDragOverClassName) {
      containerRef.current.classList.add(onDragOverClassName);
    }
  }, [onDragOverClassName, containerRef]);
  var onDrop = useCallback(function (e) {
    e.preventDefault();
    e.persist();
    handleEnd();
    handleDropUpload(e);
  }, [handleEnd, handleDropUpload]);
  var onDragLeave = useCallback(function () {
    handleEnd();
  }, [handleEnd]);
  var onDragEnd = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    handleEnd();
  }, [handleEnd]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: className,
    ref: containerRef,
    onDragOver: onDragOver,
    onDrop: onDrop,
    onDragLeave: onDragLeave,
    onDragEnd: onDragEnd
  }, extraProps), children);
});
export default UploadDropZone;